module.exports = __webpack_public_path__ + "img/empty.9beaa462.png";